import { useEffect, useState } from "react";
import useFetchUserEmployees from "./useFetchUserEmployedStores";
import { IAppointment } from "../../services/api/Appointment/types";
import { isUserStoreManager } from "../../pages/petAndBeauty/Comercial/Appointments/functions";
import { useAuth } from "../../context/AuthProvider/useAuth";
import appointmentApi from "../../services/api/Appointment";
import { StoreData } from "../../types/types";
import { useQuery } from "@tanstack/react-query";

const useFetchComercialAppointments = () => {
  const auth = useAuth();

  const { userEmployees } = useFetchUserEmployees();

  const fetchAllUserRelatedAppointments = async () => {
    let iterableStoreAppointmentsResponse = null;
    let appointments = [];
    let employeeStores = [
      { id: "-", name: "Todos", managerId: "-" } as StoreData,
    ];

    for (const employee of userEmployees) {
      employeeStores.push({
        id: employee.storeId,
        name: employee.store.name,
        managerId: employee.store.managerId,
      });

      iterableStoreAppointmentsResponse = await (isUserStoreManager(
        auth.user.id,
        employee.store.managerId
      )
        ? appointmentApi.getAppointmentsFromStore(employee.storeId)
        : appointmentApi.getAppointmentsFromStoreAndEmployee(
            employee.storeId,
            employee.id
          ));

      appointments.push(...iterableStoreAppointmentsResponse);
    }

    return { appointments, employeeStores };
  };

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["appointments", userEmployees],
    queryFn: fetchAllUserRelatedAppointments,
    enabled: !!userEmployees,
  });

  return {
    appointments: data?.appointments || [],
    employeeStores: data?.employeeStores || [],
    isLoading,
    userEmployees,
    refetch,
  };
};

export default useFetchComercialAppointments;
